import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest, googleIdpHint } from "../../authConfig";
import NexusLogo from "../core/NexusLogo";

const Login = () => {
  const { instance } = useMsal();

  const handleMicrosoftSignIn = () => {
    instance
      .loginRedirect({
        ...loginRequest,
        redirectStartPage: window.location.href,
      })
      .catch((e) => {
        // Swallow immediate redirect errors to avoid dev error overlay; App-level MSAL listener shows dialog
        if (process.env.NODE_ENV !== "production") {
          // eslint-disable-next-line no-console
          console.debug(
            "MSAL loginRedirect (Microsoft) error:",
            e?.message || e
          );
        }
      });
  };

  const handleGoogleSignIn = () => {
    instance
      .loginRedirect({
        ...loginRequest,
        ...googleIdpHint, // Preselect Google IdP (ensure your B2C user flow has Google configured)
        redirectStartPage: window.location.href,
      })
      .catch((e) => {
        if (process.env.NODE_ENV !== "production") {
          // eslint-disable-next-line no-console
          console.debug("MSAL loginRedirect (Google) error:", e?.message || e);
        }
      });
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100 p-6">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-lg border border-slate-200 p-8">
        <div className="flex flex-col items-center gap-3 mb-6">
          <NexusLogo className="h-12 w-12" />
          <h1 className="text-2xl font-semibold text-slate-800">
            Sign in to Nexus
          </h1>
          <p className="text-slate-500 text-sm text-center">
            Continue with your Microsoft account or Google. You'll be redirected
            back to where you left off.
          </p>
        </div>

        <div className="space-y-3">
          <button
            onClick={handleMicrosoftSignIn}
            className="w-full inline-flex items-center justify-center gap-2 py-3 px-4 rounded-lg bg-blue-600 hover:bg-blue-700 text-white font-medium transition-colors"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 23 23"
              width="20"
              height="20"
            >
              <g>
                <path fill="#f35325" d="M1 1h10v10H1z" />
                <path fill="#81bc06" d="M12 1h10v10H12z" />
                <path fill="#05a6f0" d="M1 12h10v10H1z" />
                <path fill="#ffba08" d="M12 12h10v10H12z" />
              </g>
            </svg>
            Sign in with Microsoft
          </button>

          <button
            onClick={handleGoogleSignIn}
            className="w-full inline-flex items-center justify-center gap-2 py-3 px-4 rounded-lg bg-white border border-slate-300 hover:bg-slate-50 text-slate-800 font-medium transition-colors"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 48 48"
              width="20"
              height="20"
            >
              <path
                fill="#FFC107"
                d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12    s5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C33.74,6.053,29.13,4,24,4C12.955,4,4,12.955,4,24s8.955,20,20,20    s20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"
              />
              <path
                fill="#FF3D00"
                d="M6.306,14.691l6.571,4.817C14.655,16.108,18.961,13,24,13c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657    C33.74,6.053,29.13,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"
              />
              <path
                fill="#4CAF50"
                d="M24,44c5.166,0,9.82-1.977,13.361-5.189l-6.157-5.208C29.108,35.091,26.715,36,24,36    c-5.202,0-9.619-3.317-11.279-7.952l-6.525,5.025C9.568,39.556,16.227,44,24,44z"
              />
              <path
                fill="#1976D2"
                d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.082,5.602    c0.001-0.001,0.002-0.001,0.003-0.002l6.157,5.208C36.961,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"
              />
            </svg>
            Continue with Google
          </button>
        </div>

        <div className="mt-6 text-xs text-slate-500 text-center">
          By continuing, you agree to the Terms and acknowledge the Privacy
          Policy.
        </div>
      </div>
    </div>
  );
};

export default Login;
